import { FC } from 'react'
import { Container, ContainerLarge } from '../../container'
import { TimelineVideo } from '../video'
import { ReadMore } from '../../read-more'
import {
  TimelineTitle,
  TimelineTitleMask,
  TimelineIntro,
  TimelineSubtitle,
  TimelineContent,
  TimelineImage,
  TimelineAnchor,
} from '../styled'
import { YoutubeLink } from '../video/youtube-link'
import { texts } from '../../locale'
type Props = {
  scrollUp: boolean
}
export const Chapter_4: FC<Props> = ({ scrollUp }) => {
  return (
    <>
      <TimelineTitle>
        <TimelineAnchor id="chapter-4" $scrollUp={scrollUp} />
        <TimelineTitleMask />
        <img
          src={
            'https://gdb.rferl.org/01000000-0a00-0242-ba77-08dc11179616_w1920_r4.jpg'
          }
        />
        <h2>
          <span>4</span>
          Бліцкриг
          <strong>{texts.menu_8}</strong>
        </h2>
      </TimelineTitle>

      <ContainerLarge>
        <TimelineIntro>
          В Україні цей період іронічно називають «​Київ за три дні». Причин
          тому кілька: по-перше, саме такий прогноз на падіння Києва давали
          численні спікери російської пропаганди. По-друге, державна російська
          агенція «​РИА Новости» випадково опублікувала заготовану наперед
          статтю про перемогу Росії – вона була встановлена на автоматичну
          публікацію 26 лютого. По-третє, як пізніше з’ясувалось із західної
          преси, три дні опору пророкували Києву й деякі західні уряди. Саме те,
          що Україні вдалося встояти ці три дні, переломити ситуацію та
          зруйнувати плани Володимира Путіна на бліцкриг, на думку багатьох
          оглядачів, відкрило двері для серйозної, тривалої і
          високотехнологічної допомоги від Заходу на наступні роки. Менше з тим,
          цей етап був кровопролитним та болючим для України: досі тривають
          розслідування того, чому російські війська так швидко змогли пройти
          кримські перешийки, наскоком захопити південні Херсон та Маріуполь, а
          також пройти за один день всю Чорнобильську зону відчуження та зайти
          на танках у передмістя столиці. План російського бліцкригу був
          зламаний, проте багато українців пережили окупацію, зазнали тортур,
          ув’язнення або загинули.
        </TimelineIntro>

        <TimelineContent>
          <TimelineSubtitle>24 лютого</TimelineSubtitle>
          <p>
            Росія атакує українські міста з повітря та на землі. Удари крилатими
            та балістичними ракетами завдаються практично на всю глибину країни.
          </p>
          <p>
            Російські війська перетинають кордон з Україною одразу у Луганській,
            Харківській, Київській, Чернігівській, Сумській та Херсонській
            областях з боку Криму. Київську область атакує безпосередньо
            армійська авіація з десантом. Починається{' '}
            <a href="https://www.radiosvoboda.org/a/oborona-pivnoch-gostomel-sumy-zsu/32285985.html">
              бій за Гостомельський аеропорт
            </a>
            . У перший день російські війська захоплюють на сході – прикордонні
            Мілове, Вовчанськ, на півдні – Нову Каховку, Генічеськ, на півночі –
            Чорнобильську АЕС.
          </p>

          <ReadMore>
            <p>Окупанти заглиблюються у Сумську і Чернігівську області.</p>
            <TimelineVideo id={'2pJY2nqsmnU'} />
          </ReadMore>

          <TimelineSubtitle>25 лютого</TimelineSubtitle>
          <p>
            На ранок військові РФ, перетнувши Чорнобильську зону, досягають
            передмістя Києва. Одночасно на півдні вони підходять до Херсона та
            Мелітополя. Вже захоплено Конотоп та інші населені пункти Сумської й
            Чернігівської областей.
          </p>

          <TimelineSubtitle>26-27 лютого</TimelineSubtitle>
          <p>
            Російські підрозділи окуповують Мелітополь та Бердянськ Запорізької
            області. Під Києвом вони займають Бородянку, Ворзель, Бучу,
            Гостомель та інші населені пункти області. Евакуація цивільних
            жителів із цих містечок у подальший місяць ставатиме дедалі
            небезпечнішою: траси повнитимуться колонами та поодинокими
            автівками, що їх розстріляли окупанти.
          </p>
          <YoutubeLink
            posterSrc="https://gdb.rferl.org/01000000-0aff-0242-8288-08dc357148d1.jpg"
            videoId="HyQPdmD6fik"
          />

          <TimelineSubtitle>27 лютого</TimelineSubtitle>
          <p>
            Захоплено Куп’янськ у Харківській області. Цього дня російські
            війська прориваються й на вулиці Харкова. Відбувається бій у місті:
            підрозділи РФ{' '}
            <a
              href="https://www.pravda.com.ua/articles/2022/11/17/7376698/"
              target="_blank"
            >
              розбиває
            </a>{' '}
            місцева тероборона. Харків агресору не вдалось захопити: він
            атакував з північної околиці до травня, коли був, зрештою,
            відкинутий ЗСУ.
          </p>

          <TimelineSubtitle>28 лютого</TimelineSubtitle>
          <p>
            Російські війська підійшли до Маріуполя на березі Азовського моря та
            почали його блокаду, котра тривала до травня та спричинила у місті
            гуманітарну катастрофу. Увесь цей час в Маріуполі меншало
            медикаментів, а били по оточеному місту російські війська
            авіаційними бомбами – найбільш руйнівною зброєю, що взагалі
            застосовувалась у російсько-українській війні. Евакуація з оточеного
            міста була вкрай небезпечною – колони часто розстрілювали по дорозі.
            Жертви серед маруіпольців (це загиблі під завалами, від поранень,
            під час спроб виїхати) прокуратура України та різноманітні
            правозахисні організації оцінюють від кількох десятків до сотні
            тисяч людей.
          </p>
          <TimelineVideo id={'Le2tlxaVakw'} />

          <TimelineSubtitle>1 березня</TimelineSubtitle>
          <p>
            Російські війська заходять у Херсон. Цього дня відбувається{' '}
            <a
              href="https://www.pravda.com.ua/articles/2022/11/8/7375378/"
              target="_blank"
            >
              бій у Бузковому парку
            </a>
            , коли місцева тероборона з коктейлями Молотова спробувала зупинити
            колону російської бронетехніки: більшість учасників бою загинули (їх
            було від 30 до 40-ка, після деокупації Херсона було виявлено
            щонаймнеше 24 тіла загиблих. Про те, чому місто опинилося майже
            беззахисним, ми розповіли{' '}
            <a href="https://www.radiosvoboda.org/a/oborona-pivdnia-zsu/32284572.html">
              тут
            </a>
            . Захоплення Херсона також дало можливість окупантам обстрілювати з
            артилерії сусідній обласний центр, Миколаїв, це тривало протягом
            наступних 8-ми місяців. Цього ж дня окуповано Тростянець на Сумщині,
            російські війська продовжують просуватися вглиб області, пробують
            штурмувати Суми та беруть в облогу Чернігів. Обидва міста їм здобути
            на вдалося, хоча окупанти весь березень контролювали траси та
            частину території громад. Проте, і Чернігів, і Суми були сильно
            поруйновані обстрілами та авіабомбардуваннями. Російські війська
            тиснуть на Київ із передмість.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/87F80E32-E1A2-4749-80A8-5AA366006E93_w1000.jpg'
              }
            />
            <span>
              Російську танкову колону розбивають у Броварах під Києвом у
              березні
            </span>
          </TimelineImage>

          <TimelineSubtitle>3 березня</TimelineSubtitle>
          <p>
            Російські війська беруть низку міст і сіл півночі Луганщини:
            Старобільськ, Новопсков, Білолуцьк, Білокуракине, Марківку. Це
            сільськогосподарські райони, які від початку війни на Донбасі
            перебували у далекому тилу підконтрольної Україні території. У перші
            тижні масштабного вторгнення там проходили людні мітинги проти
            російських військ, потім опір був придушений. Цього ж дня окуповано
            Енергодар на Запоріжжі, де розташована найбільша у Європі АЕС.
          </p>
          <TimelineVideo id={'htffxTZJ66s'} />

          <TimelineSubtitle>4 березня</TimelineSubtitle>
          <p>Захоплена Балаклія на Харківщині.</p>

          <TimelineSubtitle>12 березня</TimelineSubtitle>
          <p>
            Російські війська беруть Волноваху, місто на шляху від Донецька до
            Маріуполя та великий залізничний вузол Донеччини. Окупації
            передували сильні бомбардування містечка, через що воно було
            поруйноване. Взяття Волновахи забезпечило армії РФ підтримку блокади
            Маріуполя, адже і зона на північ, і зона на захід від Маріуполя
            тепер контролювалися окупаційними військами.
          </p>

          <TimelineSubtitle>19 березня</TimelineSubtitle>
          <p>
            Захоплене селище Снігурівка у Миколаївській області. Загалом під
            окупацію РФ потрапили 5% цієї області. Ці території були звільнені
            під час осіннього наступу, коли українські війська пробивалися до
            Херсона. У самому Херсоні та області весь березень люди виходять на
            протести проти окупантів, допоки ті не придушують це. На цьому
            херсонці вигукують окупаційним військам: «Домой!»
          </p>
          <TimelineVideo id={'JYJGiUqMC8I'} />

          <TimelineSubtitle>22 березня</TimelineSubtitle>
          <p>
            Українські військові вибили російські підрозділи з селища Макарів.
            Цей момент поклав початок звільненню Київської області від
            окупантів.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/01f00000-0aff-0242-1803-08d9fe127ed2_w1000.jpg'
              }
            />
            <span>Українські військові під Макаровим</span>
          </TimelineImage>

          <TimelineSubtitle>28 березня-2 квітня</TimelineSubtitle>
          <p>
            Українська армія повністю звільняє Київщину: Ірпінь, Бучу,
            Гостомель, Бородянку, Мотижин, Іванків та усі населені пункти аж до
            північного кордону.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/051e0000-0aff-0242-4137-08da185e5c76_w1000.jpg'
              }
            />
            <span>Бучанці поміж спаленої російської техніки 4 квітня</span>
          </TimelineImage>

          <TimelineSubtitle>3 та 11 квітня</TimelineSubtitle>
          <p>
            Слідом за Київською, ЗСУ повністю звільняють Чернігівську і Сумську
            області. Російські війська відходять за північний кордон України.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/01000000-0aff-0242-16e1-08db3450a42b_w1000.jpg'
              }
            />
            <span>
              Українські воїни щойно звільнили село Нова Басань на Чернігівщині
            </span>
          </TimelineImage>

          <p>
            Після повернення української влади на всі території Київської,
            Сумської та Чернігівської областей почали відкриватися подробиці
            російського насильства над жителями цих регіонів, яке тривало
            протягом місяця окупації. Найвідомішими у світі стали події окупації
            у Бучі: там, за підрахунками правозахисників, загинув кожен 5-й
            житель із тих, хто залишився під владою російських військових.
            Проте, убивства та знущання відбувалися й у інших містечках та селах
            півночі України.{' '}
            <a
              href="https://youtu.be/SBcBBAAWb60?si=7ZXu9yRXH79Q8HKQ"
              target="_blank"
            >
              Розслідування
            </a>{' '}
            їхніх обставин зайняло місяці.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/01000000-0a00-0242-d870-08dc11180174_w1000.jpg'
              }
            />
            <span>
              Знищені під Ірпенем машини, якими люди покидали окуповане місто.
              Після звільнення області на них намалювали квіти
            </span>
          </TimelineImage>

          <TimelineSubtitle>3 травня</TimelineSubtitle>
          <p>
            ЗСУ відтісняють російські війська на 40 кілометрів від Харкова. Це
            мало велике значення для міста, адже доти агресор, що стояв упритул
            до міської межі, обстрілював Харків усіма видами артилерії. Під
            вогнем Харків перебував і пізніше, проте для ударів підходила вже
            лиш реактивна артилерія. Найбільш постраждалим районом міста є
            Північна Салтівка. Ось що з нею сталося після російських обстрілів:
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/02490000-0aff-0242-f07b-08dae4b05038_w1000.jpg'
              }
            />
          </TimelineImage>
        </TimelineContent>
      </ContainerLarge>
    </>
  )
}
